import { render } from "./LP.vue?vue&type=template&id=3718d582"
import script from "./LP.vue?vue&type=script&lang=js"
export * from "./LP.vue?vue&type=script&lang=js"

import exportComponent from "E:\\宿舍管理系统springboot+vue - 副本\\前端代码\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__